(function () {
    angular.module('components.navigation', [
        'ngResource',
        'utility'
    ])
        .factory('navigationService', navigationService)
        .directive('topBar', topBar)
        .directive('accordionNav', accordionNav)
        .directive('multiNav', multiNav)
        .directive('activeClass', activeClass);

    navigationService.$inject = ['$q', '$timeout', '$resource'];
    function navigationService($q, $timeout, $resource) {
        var base = '/api/main/'
        return {
            api: {
                primary: $resource(base + 'primary-nav', {}, {
                    query: {
                        cache: true,
                        isArray: true
                    }
                })
            }
        }
    }

    topBar.$inject = ['navigationService'];
    function topBar(navigationService) {
        var directive = {
            replace: true,
            restrict: 'E',
            templateUrl: '/angular/components/navigation/topBar.html'
        }
        return directive;
        function link(scope, element, attrs) {
            scope.links = navigationService.api.main.get();
            scope.openNav = function () {

            }
        }
    }

    accordionNav.$inject = ['navigationService'];
    function accordionNav(navigationService) {
        var directive = {
            replace: true,
            templateUrl: '/angular/components/navigation/accordionNav.html',
            scope: {
                links: '=?'
            },
            link: link
        };
        return directive;
        function link(scope, element, attrs) {
            if (!scope.links)
                scope.links = navigationService.api.primary.query();
        }
    }

    multiNav.$inject = ['navigationService', '$timeout', '$window'];
    function multiNav(navigationService, $timeout, $window) {
        var directive = {
            replace: true,
            restrict: 'E',
            scope: {
                links: '=?',
                rootId: '=',
                autoSize: '=?',
                maxLevel: '=?',
                onReady: '&?'
            },
            //templateUrl: '/angular/components/navigation/multiNav.html',
            template: `
                <ul class="multi-nav grid-x small-up-1" ng-class="{'auto-size': autoSize}">
                    <li class="cell level-1 level" ng-style="shift">
                        <ul>
                            <li ng-repeat="link in links|filter:{styles: '!extra-link'}" ng-class="link.styles">
                                <a ng-if="link.children.length > 0" ng-click="handleClick($event, link)" ng-class="{active: link.id === levels[0].id}"><span>{{link.name}}</span><span class="fa fa-angle-right"></span></a>
                                <a ng-if="!link.children.length" ng-href="{{link.url}}" ng-click="handleClick($event, link, 0)" ng-class="{active: link.id === levels[0].id}">{{link.name}}</a>
                            </li>
                        </ul>
                        <br ng-if="(links|filter:{styles: 'extra-link'}).length" />
                        <ul class="top-links">
                            <li ng-repeat="link in links|filter:{styles: 'extra-link'}" ng-class="link.styles">
                                <a ng-if="link.children.length > 0" ng-click="handleClick($event, link, 0)" ng-class="{active: link.id === levels[0].id}"><span>{{link.name}}</span><span class="fa fa-angle-right"></span></a>
                                <a ng-if="!link.children.length" ng-href="{{link.url}}" ng-click="handleClick($event, link, 0)" ng-class="{active: link.id === levels[0].id}">{{link.name}}</a>
                            </li>
                        </ul>
                    </li>
                    <li class="cell level-{{$index + 2}} level" ng-repeat="level in levels">
                        <ul>
                            <li class="standard"><a class="back" ng-click="back()"><span class="fa fa-arrow-left"></span> Back</a></li>
                            <li class="standard"><a class="current" ng-href="{{level.url}}" ng-click="handleClick($event, level, $index + 1)">{{level.name}}</a></li>
                            <li ng-repeat="link in level.children">
                                <a ng-if="link.children.length > 0 && link.id !== level.id" ng-click="handleClick($event, link, $index + 1)" ng-class="{active: link.id === levels[$index + 1].id}"><span>{{link.name}}</span><span class="fa fa-angle-right"></span></a>
                                <a ng-if="!link.children.length || link.id === level.id" ng-href="{{link.url}}" ng-click="handleClick($event, link, $index + 1)" ng-class="{active: link.id === levels[$index + 1].id}">{{link.name}}</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            `,
            link: link
        };
        return directive;
        function link(scope, element, attrs) {
            var currentLevel;
            if (!scope.service)
                scope.links = navigationService.api.primary.query({ rootId: scope.rootId, maxLevel: scope.maxLevel || 3 }, function (data) {
                    $timeout(function () {
                        reset();
                        if (scope.onReady) {
                            scope.onReady({ data: data });
                        }
                    });
                });
            function reset() {
                scope.levels = [];
                currentLevel = 0;
                updateTransform();
            }
            function updateTransform() {
                var size = '-' + currentLevel + '00%';
                if (scope.autoSize && Foundation.MediaQuery.current !== 'small') {
                    var levels = angular.element('.level');
                    var totalWidth = 0;
                    for (var i = 0; i <= currentLevel; i++) {
                        totalWidth += angular.element(levels[i]).width();
                    }
                    size = (element.width() - totalWidth) + 'px';
                }
                scope.shift = {
                    'margin-left': size
                };
            }
            scope.handleClick = function ($event, link, level) {
                if (link.children !== undefined && link.children.length > 0 && (scope.levels.length === 0 || link.id !== scope.levels[currentLevel - 1].id)) {
                    $event.preventDefault();
                    if (scope.levels.length > level) {
                        console.log(scope.levels.length, level);
                        scope.levels = scope.levels.slice(0, level);
                        currentLevel = level;
                    }
                    scope.levels.push(link);
                    currentLevel++;
                    $timeout(updateTransform);
                }
                else {
                    reset();
                }
            }
            scope.$root.$watch('dropdownOpen', function (val) {
                if (!val) {
                    reset();
                }
            });

            var win = angular.element($window).on('resize.multiNav', updateTransform);

            scope.$on('$destroy', function () {
                win.off('resize.multiNav');
            })

            scope.back = function () {
                scope.levels.pop();
                currentLevel--;
                updateTransform();
            }
        }
    }

    function activeClass() {
        var directive = {
            restrict: 'A',
            link: link
        };
        return directive;
        function link(scope, element, attrs) {
            var cl = attrs.activeClass;
            var path = attrs.ngHref || attrs.href;
            if (location.pathname.indexOf(path) === 0)
                element.addClass('active');
            else
                element.removeClass('active');
        }
    }
})();